
import React, { useState, useMemo } from 'react';
import { fetcher } from 'api/client';
import { fetchWebhooks, deleteWebhook, testWebhook } from 'api/actions/tenant';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';
import bootbox from 'components/Modals/Bootbox';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import { Button, ButtonGroup, Table } from 'reactstrap';
import { CONTROL_MODAL, useProfileViewDispatch } from 'context/profile-view';

function Webhook({ webhook, setResponse }) {

    const dispatch = useProfileViewDispatch();

    const { t } = useTranslation();

    const queryClient = useQueryClient();
    // ACTIONS
    const onError = ({ message = 'GeneralError' } = {}) => {
        toast.error(t(`errors.${message}`))
    }

    const { mutate: mutateDeleteWebhook } = useMutation(() =>
        fetcher(deleteWebhook({ webhookId: webhook?._id })), {
        onError,
        onSuccess: () => {
            toast.success(t('success'));
            queryClient.invalidateQueries('tenant-webhooks')
        }
    });

    const { mutate: mutateTestWebhook } = useMutation(() =>
        fetcher(testWebhook({ webhookId: webhook?._id })), {
        onError,
        onSuccess: (data) => {
            setResponse(data);
            toast.success(t('success'));
            queryClient.invalidateQueries('tenant-webhooks')
        }
    });


    // HANDLERS

    const handleTest = async () => {
        mutateTestWebhook()
    }

    const handleDelete = async () => {
        const confirm = await bootbox.confirm(t('profile.notifications.confirm_delete'));
        if (confirm) mutateDeleteWebhook();
    }

    const handleOpenWebhookModal = () => {
        dispatch({ type: CONTROL_MODAL, open: 'WEBHOOK', params: { webhook } })
    }

    return (
        <tr >
            <td className="text-wrap" style={{ 'maxWidth': '250px' }}>
                {webhook.uri}
            </td>
            <td>
                {webhook.slackAttachments ?
                    t('profile.notifications.enabled') :
                    t('profile.notifications.disabled')
                }
            </td>
            <td>
                <ul>
                    {webhook.notifyEvents?.map((event, index) => (
                        <li key={`${event} - ${index}`}>
                            {t('profile.notifications.events.' + event)}
                        </li>
                    ))
                    }
                </ul>
            </td>
            <td className="text-center" style={{ 'maxWidth': '100px' }}>
                <ButtonGroup vertical>
                    <Button
                        // color="success"
                        outline
                        onClick={handleOpenWebhookModal}
                    >
                        <i className="fas fa-edit"></i>
                        {' ' + t('profile.notifications.edit')}
                    </Button>
                    <Button
                        // color="danger"
                        outline
                        onClick={handleDelete}
                    >
                        <i className="fas fa-times"></i>
                        {' ' + t('profile.notifications.delete')}
                    </Button>
                    <Button
                        // color="warning"
                        outline
                        onClick={handleTest}
                    >
                        <i className="fas fa-check"></i>
                        {' ' + t('profile.notifications.test')}
                    </Button>
                </ButtonGroup>
            </td>
        </tr>
    )
}

export default function Webhooks() {

    const { t } = useTranslation();

    const [response, setResponse] = useState()

    const dispatch = useProfileViewDispatch();

    const { data, isSuccess } = useQuery('tenant-webhooks', () => fetcher(fetchWebhooks()));

    const handleOpenModal = () => {
        dispatch({ type: CONTROL_MODAL, open: 'WEBHOOK', params: {} })
    }

    return (
        <div className="profile-users">
            <h5>
                <i className="fas fa-bell"></i> {t('profile.notifications.title')}
            </h5>
            <p>
                {t('profile.notifications.add')}
                <Button className="float-right text-primary" size="sm" color="default" onClick={handleOpenModal} > <i className="fas fa-plus"></i> {t('profile.notifications.add_new')}</Button>
            </p>
            <Table hover responsive>
                <thead>
                    <tr>
                        <th>URL</th>
                        <th>Slack</th>
                        <th>{t('profile.notifications.events_title')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {isSuccess && data?.map((webhook) => (
                        <Webhook key={webhook._id} webhook={webhook} setResponse={setResponse} />
                    ))}
                </tbody>
            </Table>
            <div>
                <span>{t('profile.notifications.response')}</span>
                <textarea
                    className="form-input"
                    name="request-result"
                    id="request-result"
                    style={{ width: '100%', height: '300px' }}
                    disabled={true}
                    value={JSON.stringify(response)}
                />
            </div>
        </div>
    )
}
